import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  current:string=new Date().getFullYear().toString();
  constructor() { }

  ngOnInit(): void {
    if ($('#preloader').length) {
      $('#preloader').delay(100).fadeOut('slow', function() {
        $(this).remove();
      });
    }
  }

  topposition(){  

    // if ($('#preloader').length) {
    //   $('#preloader').delay(500).fadeOut('slow', function() {
    //     $(this).remove();
    //   });
    // }
    $('html, body').animate({
      scrollTop: 0
    }, 1000, 'easeInOutExpo');

    //this.menuClicked();
    return false;
  }

}
